import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import MeetingRooms from "../pages/meeting-rooms/MeetingRooms";
import Pool from "../pages/pool/Pool";
import Numbers from "../pages/numbers/Numbers";
import ErrorsPage from "../pages/errors-page/ErrorsPage";
import { useContext, useEffect } from "react";
import { GlobalContext } from "../components/layout/global-context/globalContext";
import { getOrchestratorErrorsData } from "../api/errors/getOrchestratorErrorsData";

const BrowserRoutes = () => {
  const { setErrorsQtty } = useContext(GlobalContext);
  const location = useLocation();
  useEffect(() => {
    if (location.pathname !== "/errors") {
      getOrchestratorErrorsData().then((response) => {
        if (response.data) {
          setErrorsQtty(response.data.length);
        }
        return null;
      });
    }
  }, [location, setErrorsQtty]);

  return (
    <>
      <div className="h-full overflow-auto no-scrollbar flex bg-white min-w-[700px] pb-1 relative">
        <Routes>
          <Route path="/numbers" element={<Numbers />} />
          <Route path="/pool" element={<Pool />} />
          <Route path="/meeting-rooms" element={<MeetingRooms />} />
          <Route path="/errors" element={<ErrorsPage />} />
          <Route path="/" element={<Navigate to="/numbers" replace />} />
          <Route path="*" element={<Navigate to="/numbers" replace />} />
        </Routes>
      </div>
    </>
  );
};

export default BrowserRoutes;
